export default {
  height:'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 4,
  searchSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label:"岗位",
      prop:"createPostString",
      type:"input",
      width: 100
    },
    {
      label: "反馈人",
      prop: "createUserString",
      type: "input",
      width: 90
    },
    {
      label: "所属代理商",
      prop: "createDeptString",
      type: "input",
      width: 120
    },
    {
      label: "问题类型",
      prop: "questionType",
      type: "select",
      dicUrl: "/api/blade-userQuestion/userQuestion/question-type-list",
      props: {
        label: "label",
        value: "value"
      },
      search: true,
      width: 110
    },
    {
      label: "问题详情",
      prop: "content",
      type: "textarea",
      span: 24,
      width: 220,
      overHidden: true,
    },
    {
      label: "联系方式",
      prop: "phone",
      type: "input",
      width: 100
    },
    {
      label: "问题图片",
      prop: "fillDataImageList",
      type: "upload",
      fileType: "img",
      dataType: 'object',
      formatter(row, value, label, column) {
        if(!value || value.length === 0) {
          return []
        }
        return value.map((item) => {
          return item.url
        })
      }
    },
    {
      label: "处理状态",
      prop: "status",
      type: "select",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      dicData: [
        {
          label: "未处理",
          value: "1"
        },
        {
          label: "已处理",
          value: "2"
        },
      ],
      width: 80
    },
    {
      label: "处理结果",
      prop: "feedbackList",
      type: "textarea",
      span: 24,
      width: 220,
      formatter(row, value, label, column) {
        if(!value || value.length === 0) {
          return ""
        }
        return value[0].content
      }
    },
    {
      label: "处理时间",
      prop: "doneTime",
      type: "input",
      display: false,
    },
    {
      label: "所属代理商",
      prop: "createDept",
      type: "select",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
  ]
}
